/**
 * ITER 69 — Hook `usePartnerTracking`.
 *
 * DRY: estrae la logica di lettura partner/sede/azienda dai query params
 * (`?partner=X&sede=Y&azienda=Z` o alias `?utm_source=X`).
 *
 * Prima di questo hook, la logica era duplicata in QuestionnairePage, RcaWizard,
 * PreventivoCasa/Vita/Salute/ViaggioPage, ecc. — con rischio di drift fra i wizard.
 *
 * Ritorna un oggetto `{ partnerId, sede, azienda, canale, metadata }` pronto
 * da spread nel payload del submit backend.
 *
 * Esempio d'uso:
 *   const { partnerId, sede, azienda, metadata } = usePartnerTracking();
 *   axios.post("/api/submissions", { ..., partner_id: partnerId, metadata });
 */
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export default function usePartnerTracking() {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    // Fallback partner ← `partner` OR `utm_source` (alias di convenzione).
    const partnerId =
      searchParams.get("partner") || searchParams.get("utm_source") || null;
    const sede = searchParams.get("sede") || null;
    const azienda = searchParams.get("azienda") || null;

    const canale = partnerId ? "convenzione" : "diretto";

    // Oggetto `metadata` normalizzato — schema compat con backend famiglia
    // (utm_source cross-ramo per filtro `/admin/richieste?partner=X`).
    const metadata = {
      utm_source: partnerId,
      sede,
      azienda,
      canale,
    };

    return { partnerId, sede, azienda, canale, metadata };
  }, [searchParams]);
}
